import axios from 'axios';
const apiKey = "AIzaSyCf2k8RM7tFFlVGo4CVPvCsOhx86vWwTT0";

export function getYoutubeTitle(videoId) {
    return new Promise(async (resolve, reject) => {
        let data = await axios.get(
            "https://www.googleapis.com/youtube/v3/videos?id=" +
                videoId + "&key="+ apiKey + "&fields=items(snippet(title))&part=snippet");
        if (data.data.items[0] !== undefined) {
            resolve(data.data.items[0].snippet.title);
        } else {
            resolve('Title not found');
        }
    });
}

